import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";

import useThemeMode from "../../hooks/useThemeMode";
import { getMarketingTheme } from "../../utils/marketingTheme";

function RelatedArticles({ articles = [] }) {
  const { isDark } = useThemeMode();
  const colors = getMarketingTheme(isDark);

  return (
    <section
      style={{
        marginTop: "42px"
      }}
    >
      <h2
        style={{
          fontSize: "32px",
          marginBottom: "12px",
          color: colors.text,
          letterSpacing: "-0.03em"
        }}
      >
        Related Articles
      </h2>

      <p
        style={{
          color: colors.textMuted,
          marginBottom: "24px",
          lineHeight: "1.7"
        }}
      >
        Continue exploring creator growth, hooks, retention,
        captions, and viral content strategy.
      </p>

      <div
        style={{
          display: "grid",
          gap: "18px"
        }}
      >
        {articles.map((article) => (
          <Link
            key={article.slug}
            to={article.slug}
            style={{
              textDecoration: "none",
              background: colors.cardBg,
              border: `1px solid ${colors.border}`,
              borderRadius: "24px",
              padding: "22px",
              transition: "all 0.25s ease",
              display: "block"
            }}
          >
            <div
              style={{
                display: "inline-flex",
                padding: "6px 12px",
                borderRadius: "999px",
                background: colors.badgeBg,
                color: colors.badgeText,
                fontSize: "12px",
                fontWeight: "700",
                marginBottom: "16px"
              }}
            >
              {article.category}
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "16px"
              }}
            >
              <div>
                <h3
                  style={{
                    margin: "0 0 12px",
                    color: colors.text,
                    fontSize: "26px",
                    lineHeight: "1.25"
                  }}
                >
                  {article.title}
                </h3>

                <p
                  style={{
                    margin: 0,
                    color: colors.textMuted,
                    lineHeight: "1.8",
                    fontSize: "15px"
                  }}
                >
                  {article.description}
                </p>
              </div>

              <div
                style={{
                  minWidth: "42px",
                  height: "42px",
                  borderRadius: "999px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: `1px solid ${colors.border}`,
                  color: colors.text
                }}
              >
                <FiArrowUpRight size={18} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default RelatedArticles;